import { call, put } from 'redux-saga/effects'
import { baseFetchToken, baseFetchTokenFullResponse } from './BaseSaga'
import AttractionActions from '../Redux/AttractionRedux'
import AuthActions from '../Redux/AuthRedux'
import { getToken } from '../Services/GetToken'

export function * getAttractionByDestination (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getAttractionByDestination, token, action.data)
      if (!res.ok) {
        yield put(AttractionActions.attractionFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const DATA_WITH_PAGE = {
            data: res.data.data,
            page,
            total
          }
          yield put(AttractionActions.attractionSuccess(DATA_WITH_PAGE))
        } else {
          yield put(AttractionActions.attractionFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(AttractionActions.attractionFailure())
  }
}

export function * getPlacesV2 (api, action) {
  yield baseFetchTokenFullResponse(
    api.getPlacesV2,
    action.data,
    getToken,
    AttractionActions.getPlacesV2Success,
    AttractionActions.getPlacesV2Failure
  )
}

export function * getPlacesByDestination (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getPlacesByDestination, token, action.data)
      if (!res.ok) {
        yield put(AttractionActions.placeFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const DATA_WITH_PAGE = {
            data: res.data.data,
            page,
            total
          }
          yield put(AttractionActions.placeSuccess(DATA_WITH_PAGE))
        } else {
          yield put(AttractionActions.placeFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(AttractionActions.placeFailure())
  }
}

export function * getAttractionDetail (api, action) {
  yield baseFetchToken(
    api.getAttractionDetail,
    action.data,
    getToken,
    AttractionActions.attractionDetailSuccess,
    AttractionActions.attractionDetailFailure
  )
}

export function * getPlaceDetail (api, action) {
  yield baseFetchToken(
    api.getPlaceDetail,
    action.data,
    getToken,
    AttractionActions.attractionDetailSuccess,
    AttractionActions.attractionDetailFailure
  )
}

export function * updateAttractionDetail (api, action) {
  yield baseFetchToken(
    api.updateAttractionDetail,
    action.data,
    getToken,
    AttractionActions.attractionUpdateSuccess,
    AttractionActions.attractionUpdateFailure
  )
}

export function * attractionClearCache (api, action) {
  yield baseFetchToken(
    api.clearAttractionCache,
    action,
    getToken,
    AttractionActions.attractionClearCacheSuccess,
    AttractionActions.attractionClearCacheFailure
  )
}

export function * searchAttraction (api, { data }) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.searchAttraction, token, data)
      if (!res.ok) {
        yield put(AttractionActions.attractionSearchFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const DATA_WITH_PAGE = {
            data: res.data.data,
            page,
            total
          }
          yield put(AttractionActions.attractionSearchSuccess(DATA_WITH_PAGE))
        } else {
          yield put(AttractionActions.attractionSearchFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(AttractionActions.attractionSearchFailure())
  }
}

export function * searchPlace (api, { data }) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.searchPlaces, token, data)
      if (!res.ok) {
        yield put(AttractionActions.placeSearchFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const DATA_WITH_PAGE = {
            data: res.data.data,
            page,
            total
          }
          yield put(AttractionActions.placeSearchSuccess(DATA_WITH_PAGE))
        } else {
          yield put(AttractionActions.placeSearchFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(AttractionActions.placeSearchFailure())
  }
}

export function * downloadAttractionData (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.downloadAttractionData, token, action.filter)
      if (!res.ok) {
        yield put(AttractionActions.downloadAttractionDataFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          yield put(AttractionActions.downloadAttractionDataSuccess(res.data))
        } else {
          yield put(AttractionActions.downloadAttractionDataFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(AttractionActions.downloadAttractionDataFailure())
  }
}



// WEBPACK FOOTER //
// ./src/Sagas/AttractionSagas.js